"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardHeader = _interopRequireDefault(require("UIComponents/card/UICardHeader"));

var _default = (0, _createReactClass.default)({
  displayName: 'SidebarAbstractCard',
  propTypes: {
    cardSectionClassName: _propTypes.default.string,
    children: _propTypes.default.node.isRequired,
    className: _propTypes.default.string,
    collapsible: _propTypes.default.bool.isRequired,
    onExpandedChange: _propTypes.default.func,
    expanded: _propTypes.default.bool.isRequired,
    title: _propTypes.default.node,
    toolbar: _propTypes.default.node,
    sidebarKey: _propTypes.default.string,
    'data-selenium-component': _propTypes.default.string
  },
  getDefaultProps: function getDefaultProps() {
    return {
      collapsible: false,
      expanded: true
    };
  },
  renderHeader: function renderHeader() {
    var _this$props = this.props,
        toolbar = _this$props.toolbar,
        title = _this$props.title;

    if (!toolbar && !title) {
      return undefined;
    }

    return _react.default.createElement(_UICardHeader.default, {
      title: title,
      titleSize: "small",
      toolbar: toolbar
    });
  },
  renderBody: function renderBody() {
    var _this$props2 = this.props,
        expanded = _this$props2.expanded,
        children = _this$props2.children;

    if (!expanded) {
      return undefined;
    }

    return children;
  },
  render: function render() {
    var _this$props3 = this.props,
        className = _this$props3.className,
        collapsible = _this$props3.collapsible,
        onExpandedChange = _this$props3.onExpandedChange,
        expanded = _this$props3.expanded,
        sidebarKey = _this$props3.sidebarKey,
        cardSectionClassName = _this$props3.cardSectionClassName;
    return _react.default.createElement(_UICardWrapper.default, {
      className: className,
      expandable: collapsible,
      compact: true,
      onExpandedChange: onExpandedChange,
      expanded: expanded,
      "data-selenium-expanded": expanded,
      "data-selenium-component": this.props['data-selenium-component'],
      "data-sidebar-key": sidebarKey
    }, this.renderHeader(), _react.default.createElement(_UICardSection.default, {
      className: cardSectionClassName
    }, this.renderBody()));
  }
});

exports.default = _default;
module.exports = exports.default;